import API from "api.provider";

const pathwaysService = {
  // Dashboard
  getDashboard: () => API.get("/api/v2/pathways/dashboard"),
  getGuests: (params) => API.get("/api/v2/pathways/guests", { params }),
  getGuestResponses: (guestId) => API.get(`/api/v2/pathways/guests/${guestId}/responses`),

  // Onboarding
  getSurveyQuestions: () => API.get("/api/v2/pathways/survey-questions"),
  syncPco: () => API.post("/api/v2/pathways/onboarding/sync-pco"),
  approveSurvey: (questions) => API.post("/api/v2/pathways/onboarding/approve-survey", { questions }),
  setSetupMode: (setupMode) => API.post("/api/v2/pathways/onboarding/setup-mode", { setupMode }),
  getConnectionStatus: () => API.get("/api/v2/pathways/onboarding/connection-status"),
  completeOnboarding: () => API.post("/api/v2/pathways/onboarding/complete"),

  // Actions
  sendSurvey: (guestId) => API.post(`/api/v2/pathways/guests/${guestId}/send-survey`),
  updateSettings: (settings) => API.patch("/api/v2/pathways/settings", settings),
  addGuest: (payload) => API.post("/api/v2/pathways/guests", payload),
  detectCsvColumns: (headers) => API.post("/api/v2/pathways/guests/import/detect", { headers }),
  previewCsvImport: (rows) => API.post("/api/v2/pathways/guests/import/preview", { rows }),
  importCsv: (rows, updateExisting) => API.post("/api/v2/pathways/guests/import", { rows, updateExisting }),
};

export default pathwaysService;
